/**
 * Featured Cards - AJAX Pagination
 *
 * Handles loading more openpub items via AJAX when pagination is enabled.
 */
( function () {
	'use strict';

	/**
	 * Initialize pagination for all featured cards blocks with load more buttons.
	 */
	function initPagination() {
		const loadMoreButtons = document.querySelectorAll( '.featured-cards__load-more' );

		loadMoreButtons.forEach( function ( button ) {
			button.addEventListener( 'click', handleLoadMore );
		} );
	}

	/**
	 * Handle the load more button click.
	 *
	 * @param {Event} event The click event.
	 */
	function handleLoadMore( event ) {
		const button = event.currentTarget;
		const blockId = button.dataset.blockId;
		const config = JSON.parse( button.dataset.paginationConfig );
		const block = document.getElementById( blockId );

		if ( ! block || button.disabled ) {
			return;
		}

		// Set loading state.
		button.disabled = true;
		button.classList.add( 'is-loading' );

		// Calculate next page.
		const nextPage = config.currentPage + 1;

		// Make AJAX request.
		const formData = new FormData();
		formData.append( 'action', 'owc_featured_cards_load_more' );
		formData.append( 'nonce', window.owcFeaturedCardsNonce || '' );
		formData.append( 'page', nextPage || 2 );
		formData.append( 'category', config.category || '' );
		formData.append( 'limit', config.limit || 9 );
		formData.append( 'show_excerpt', config.showExcerpt ? '1' : '0' );
		formData.append( 'show_date', config.showDate ? '1' : '0' );
		formData.append( 'card_type', config.cardType || 'news-card' );
		formData.append( 'card_bg', config.cardBg || 'primary-200' );

		fetch( window.ajaxurl, {
			method: 'POST',
			body: formData,
			credentials: 'same-origin',
		} )
			.then( function ( response ) {
				return response.json();
			} )
			.then( function ( data ) {
				if ( data.success && data.data.html ) {
					// Find the cards container and append new items.
					const cardsContainer = block.querySelector( '.featured-cards-wrap__cards' );
					if ( cardsContainer ) {
						cardsContainer.insertAdjacentHTML( 'beforeend', data.data.html );
					}

					// Update config with new page number.
					config.currentPage = nextPage;
					button.dataset.paginationConfig = JSON.stringify( config );

					// Hide button if we've reached the last page.
					if ( nextPage >= config.totalPages ) {
						button.style.display = 'none';
					}
				} else {
					// eslint-disable-next-line no-console
					console.error( 'Failed to load more items:', data );
				}
			} )
			.catch( function ( error ) {
				// eslint-disable-next-line no-console
				console.error( 'AJAX error:', error );
			} )
			.finally( function () {
				// Remove loading state.
				button.disabled = false;
				button.classList.remove( 'is-loading' );
			} );
	}

	// Initialize when DOM is ready.
	if ( document.readyState === 'loading' ) {
		document.addEventListener( 'DOMContentLoaded', initPagination );
	} else {
		initPagination();
	}
} )();
